// The converted assets (docs/platform/AssetConv.md), served by the match server at /assets/<path>.
// Every fetch carries the manifest's sha256 as `?v=`, which the server answers as immutable
// (netcode.md §9), so the browser cache keeps them across matches.

type ManifestFile = { sha256: string; bytes: number };
type Manifest = { version: number; files: Record<string, ManifestFile>; sha256: string };

let manifest: Manifest | null = null;

export async function loadManifest(): Promise<void> {
  const r = await fetch('/assets/manifest.json', { cache: 'no-cache' });
  if (!r.ok) throw new Error(`assets/manifest.json: HTTP ${r.status}`);
  manifest = await r.json();
}

/** The URL of a logical asset path (immutable when the manifest lists it). */
export function assetUrl(path: string): string {
  const f = manifest?.files[path];
  return f ? `/assets/${path}?v=${f.sha256}` : `/assets/${path}`;
}

export function hasAsset(path: string): boolean {
  return !!manifest?.files[path];
}

export async function assetBytes(path: string): Promise<ArrayBuffer> {
  const r = await fetch(assetUrl(path));
  if (!r.ok) throw new Error(`${path}: HTTP ${r.status}`);
  return r.arrayBuffer();
}

export async function assetJson<T>(path: string): Promise<T> {
  const r = await fetch(assetUrl(path));
  if (!r.ok) throw new Error(`${path}: HTTP ${r.status}`);
  return r.json();
}
